//zustand store for handling browser local storage

import { create } from 'zustand';

// Get initial session token from localStorage
const getInitialSessionToken = () => {
  try {
    return localStorage.getItem('sessionToken') || '';
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return '';
  }
};

export type LocalStorageState = {
  sessionToken: string;
  setSessionToken: (token: string) => void;

  isFetchingToken: boolean;
  setIsFetchingToken: (isFetchingToken: boolean) => void;

  clearAllStorageData: () => void;
};

export const useLocalStorage = create<LocalStorageState>(set => ({
  sessionToken: getInitialSessionToken(),
  setSessionToken: token => {
    try {
      localStorage.setItem('sessionToken', token);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
    set({ sessionToken: token });
  },

  isFetchingToken: false,
  setIsFetchingToken: isFetchingToken => set({ isFetchingToken }),

  clearAllStorageData: () => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  },
}));
